import DashboardVentasB2B from "../components/VentasB2B/DashboardVentasB2B";

export default function VentasB2BPage() {
  return <DashboardVentasB2B />;
}
